export const typesGlobalState = {
  authLogin: '[user] login',
  authLogout: '[user] logout',
};
